
export default function ContactInfo() {
  const contactMethods = [
    {
      icon: 'ri-map-pin-line',
      title: 'Our Location',
      details: [
        'E-501, Sector-2, Sun City',
        'Bhopal',
        'Near S.P. Ring Road',
        'Ahmedabad - 380058'
      ],
      action: '',
      link: 'https://maps.google.com/?q=E-501+Sector-2+Sun+City+Near+SP+Ring+Road+Ahmedabad+380058'
    }
    ,
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: [
        '+91 9839923648',
        ' +91 8052671091'
      ],
      action: 'Call Us',
      link: 'tel: +918052671091'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: [
        'info@esterlifesciences.com',
      ],
      action: 'Send Email',
      link: 'mailto:info@esterlifesciences.com'
    },
    {
      icon: 'ri-time-line',
      title: 'Working Hours',
      details: [
        'Monday - Friday: 9:00 AM - 6:00 PM',
        'Saturday: 9:00 AM - 2:00 PM',
        'Sunday: Closed',
        'Emergency: 24/7 Available'
      ],
      action: 'View Schedule',
      link: '#business-hours'
    }
  ];

  return (
    <section className="py-24 px-4 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            How to Reach Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Multiple ways to connect with our team. Choose what works best for you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {contactMethods.map((method, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${method.icon} text-3xl text-white`}></i>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {method.title}
              </h3>

              <div className="space-y-2 mb-6">
                {method.details.map((detail, idx) => (
                  <p key={idx} className="text-sm text-gray-600">
                    {detail}
                  </p>
                ))}
              </div>

              <a
                href={method.link}
                className="whitespace-nowrap inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer"
              >
                {method.action}
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
